<pds-module-header title="Padrões de grupo de produtos" ctaLabel="Novo padrão" ctaPath="/operacoes/padroes-grupo-produtos/novo">
  <pds-new-breadcrumb [items]="breadcrumbItems" />

  <pds-panel>
    <form class="product-group-defaults-filter" [formGroup]="searchForm" (ngSubmit)="onSubmitSearch()">
      <pds-form-row grid="1">
        <div class="product-group-defaults-filter__group">
          <label class="product-group-defaults-filter__label">Grupo de Produto</label>
          <pds-multi-select-autocomplete
            formControlName="productGroup"
            [source]="productGroupSource"
            placeholder="Pesquisar grupo de produtos"
            (autocomplete)="onProductGroupAutocomplete($event)"
          />
        </div>
      </pds-form-row>

      <pds-form-actions>
        <button pdsButton="secondary" modifier="outlined" type="button" (click)="clearFilters()">
          Limpar
        </button>
        <button pdsButton type="submit">
          Buscar
        </button>
      </pds-form-actions>
    </form>

    <hr />

    <div class="product-group-defaults-content">
      <ng-container *ngIf="state.data && state.data.length > 0">
        <pds-table>
          <table>
            <thead>
              <tr>
                <th>Grupo de Produto</th>
                <th>Atualizado em</th>
                <th>Atualizado por</th>
                <th pdsColActions>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of items">
                <td>{{ item.productGroupName }}</td>
                <td>{{ item.updatedAt ? (item.updatedAt | date : 'dd/MM/yyyy HH:mm') : '-' }}</td>
                <td>{{ item.updatedBy || '-' }}</td>
                <td pdsColActions>
                  <button pdsButton="icon" modifier="outlined" title="Editar" (click)="onClickEdit(item)">
                    <span class="icon">edit</span>
                  </button>
                  <button pdsButton="icon" modifier="outlined" title="Excluir" (click)="onClickDelete(item)">
                    <span class="icon">delete</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </pds-table>

        <pds-pagination [pagination]="pagination$" (paginate)="onPaginate($event)" />
      </ng-container>

      <ng-container *ngIf="state.data && state.data.length === 0">
        <strong>Nenhum padrão de grupo de produtos encontrado.</strong>
      </ng-container>

      <ng-container *ngIf="state.failure">
        <pds-alert type="error" title="Erro ao carregar os padrões de grupo de produtos">
          Não foi possível carregar a lista. Tente novamente em instantes.
        </pds-alert>
      </ng-container>
    </div>
  </pds-panel>
</pds-module-header>
